import clsx from 'clsx';

/** Navbar action button with icon + optional label. */
export function navActionButtonClass({ active = false, accent = false } = {}) {
  return clsx(
    'relative inline-flex h-9 items-center justify-center gap-2 shrink-0 px-3',
    'rounded-xl text-xs font-semibold transition-all duration-200',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40 focus-visible:ring-offset-2',
    accent
      ? clsx(
          'border border-brand-300/70 bg-gradient-to-b from-brand-50 to-brand-100/80 text-brand-700',
          'hover:border-brand-400 hover:from-brand-100 hover:to-brand-100 shadow-sm shadow-brand-500/10',
          active && 'border-brand-500 bg-brand-100 text-brand-800 shadow-md shadow-brand-500/15',
        )
      : clsx(
          'border border-surface-200 bg-white text-surface-700',
          'hover:border-surface-300 hover:bg-surface-50 hover:text-dark-900 shadow-sm',
          active && 'border-brand-400/80 bg-brand-50/60 text-brand-800 shadow-md shadow-brand-500/10',
        ),
  );
}
